import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { CustomerFragmentDoc } from './Customer.generated';
import { WholesaleAppFragmentDoc } from './WholesaleApp.generated';
export type UserFragment = { id: string, pk: number, firstName: string, lastName: string, isStaff: boolean, isActive: boolean, isSuperuser: boolean, email: string, subscriptions: boolean, permissions: Array<string>, totalPointsBalance: number, totalPointsBalanceAvailable: number, minRpThreshold: number, isImpersonate: boolean, totalBalance: { currency: string, gross: number }, totalBalanceAvailable: { currency: string, gross: number }, customer: { id: string, pk: number, email: string, firstName: string, lastName: string, sendNotifications: boolean, subscribed: boolean, activationCode: string, subscriptionTypes: Array<{ id: string, pk: number, subscriptionType: Types.SubscriptionTypeEnum, name: string, description: string, sortOrder: number }>, discount: { id: string, pk: number, value: any } | null }, wholesaleApp: { id: string, pk: number, created: any, email: string, storeName: string, storeType: Types.StoreTypeEnum, storeYear: number | null, websiteUrl: string | null, instagramUrl: string | null, facebookUrl: string | null, brands: Array<string>, storeDescription: Array<string>, status: Types.WholesaleAppStatusEnum, initialAddress: { firstName: string | null, lastName: string | null, country: Types.CountryCodeEnum | null, city: string | null } | null } | null };

export const UserFragmentDoc = gql`
    fragment UserFragment on UserType {
  id
  pk
  firstName
  lastName
  isStaff
  isActive
  isSuperuser
  email
  subscriptions
  permissions
  totalPointsBalance
  totalPointsBalanceAvailable
  totalBalance {
    currency
    gross
  }
  totalBalanceAvailable {
    currency
    gross
  }
  minRpThreshold
  isImpersonate
  customer {
    ...CustomerFragment
  }
  wholesaleApp {
    ...WholesaleAppFragment
  }
}
    ${CustomerFragmentDoc}
${WholesaleAppFragmentDoc}`;